<template>
  <div class="toShare">
    <!--<van-nav-bar title="分享" left-arrow @click-left="goBack"/>-->
    <div class="lunbo" :style="swiperBox">
    	<span class="tip">选择海报</span>
	    <swiper :options="swiperOption" ref="mySwiper" v-if="code && imgs[0]">
	      <swiper-slide :style="swiperH"><span class="index">0</span>
	      	<img class="bg" :src="imgs[0]"/>
	      	<img class="qrcode" :style="codestyle" :src="code" />
	      </swiper-slide>
	      <swiper-slide :style="swiperH"><span class="index">1</span>
	      	<img class="bg" :src="imgs[1]"/>
	      	<img class="qrcode" :style="codestyle" :src="code" />
	      </swiper-slide>
	      <swiper-slide :style="swiperH"><span class="index">2</span>
	      	<img class="bg" :src="imgs[2]"/>
	      	<img class="qrcode" :style="codestyle" :src="code" />
	      </swiper-slide>
	      
	      <div class="swiper-pagination" slot="pagination"></div>
	    </swiper>
    </div>
    <div class="share-btn">
      <div class="share_">
        <span class="register">注册成功的好友每笔有效订单，都可给你创造收益</span>
      </div>
      <div class="btn">
        <span class="btn--" @click="sharePoster()">分享海报</span>
        <span class="btn---" @click="shareUrl()">分享链接</span>
      </div>
    </div>
    <div class="rule">
      <div class="shareRule">
        <span>分享规则</span>
      </div>
      
      <div class="rule-i">
        
        <div class="rule-j" v-html="rules">
          
        </div>
      </div>
      
      <!--<div class="rule-i">
        <div class="circle">
          <span class="crl"></span>
        </div>
        <span class="rule-j">
          好友通过你的二维码下载销巴生活，并成功注册登录，则算分享成功；
        </span>
      </div>
      <div class="rule-i">
        <div class="circle">
          <span class="crl"></span>
        </div>
        <span class="rule-j">
          分享成功的好友将成为你的会员，会员通过销巴生活完成的每一笔有效订单，都能给你创造收益；
        </span>
      </div>
      <div class="rule-i">
        <div class="circle">
          <span class="crl"></span>
        </div>
        <span class="rule-j">
          禁止通过作弊手段进行虚假分享注册来骗取奖励，如有发现，将取消其奖励并酌情处罚；
        </span>
      </div>
      <div class="rule-i">
        <div class="circle">
          <span class="crl"></span>
        </div>
        <span class="rule-j">本活动最终解释权归销巴生活所有。</span>
      </div>-->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      swiperOption: {
      	pagination: {
	        el: '.swiper-pagination',
	        type: 'fraction'
	        //clickable: true // 允许点击小圆点跳转
	    	},
        spaceBetween: -12,
        slidesPerView: "auto",
        loop: true,
        slidesPerGroup: 1,
        centeredSlides: true,
        watchSlidesProgress: true,
        on: {
          progress: function() {
            for (let i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              var scale = 1 - Math.abs(slideProgress) / 4;
              slide.transform("scale(" + scale + ")");
            }
          }
        }
      },
      label: 0,
      currentTab: "0",
      share_Url: '',
      code:'',
      codestyle:{
	      width: document.body.clientWidth / 2 * 0.22 + 'px',
	      height: document.body.clientWidth / 2 * 0.22 + 'px',
	      left: document.body.clientWidth / 2 * 0.05 + 'px',
	      bottom: document.body.clientWidth / 2 * 0.05 - 2 + 'px'
	    },
		rules:'',
		imgs:[],
		swiperH: {'height': document.body.clientWidth / 2 * 1.78+'px'},
		swiperBox: {'height': document.body.clientWidth / 2 * 1.78 + 51+'px'}
    };
  },
  created (){
//	this.swiperH = {'height': document.body.clientWidth / 2 * 1.78+'px'}
  	//this.$route.path = '/toShare' 页面路由
  	var baseUrl = window.location.href.split(this.$route.path)
		this.$api.setToken(this.$route.query.token);
		this.share_Url = baseUrl[0]+'/share?shareCode='+this.$route.query.shareCode+'&mobile='+this.$route.query.mobile;
		this.getPoster();
		this.getCode();
  },
  methods: {
  	getPoster() {
    	this.$api.post("/task/index/task/detail",{task_type:3}).then(res => {
	        this.rules = res.link_page_params.shareRule;
	        this.imgs = res.link_page_params.sharePoster;
	    });
    },
  	getCode() {
    	this.$api.post("/member/member/member/qrcode",{url:this.share_Url}).then(res => {
          if(res.img) {
            this.code = res.img;
          }else {
            this.$api.post("/membe/member/rmember/update/qrcode").then(res => {
              this.code = res.share_code;
            });
          }
	    });
    },
    sharePoster() {
    	var index = document.querySelector('.swiper-slide-active .index').innerText;
    	var poster = this.imgs[index]; 
      
      let canvas = document.createElement('canvas');
      canvas.width = 375;
      canvas.height = 667;
      let ctx = canvas.getContext('2d');
      
      let bg = new Image();
      bg.setAttribute('crossorigin','anonymous');
      bg.src=poster;
      bg.onload = () => {
      	ctx.drawImage(bg,0, 0, 375, 667);
      	
	   		let cd = new Image();
			  cd.setAttribute('crossorigin','anonymous');
			  cd.src=this.code;
			  cd.onload = () => {
			  	ctx.drawImage(cd,15, 567, 85, 85);
			  	
          this.newSrc = canvas.toDataURL();
			    this.params([poster,this.code], this.newSrc, 'sharePoster');
			  }
      }
    },
    shareUrl() {
			this.$api.get("/ongoods/index/config/sharing-copy/get").then(res => {
	        var share = res.value.share_app;
	        var result = [share.title, share.icon, share.description];
	        let ua = navigator.userAgent.toLowerCase();
			    if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
			        window.webkit.messageHandlers.shareUrl.postMessage(result)
			    } else if (/android/.test(ua)) {
			        window.AndroidToast.shareUrl(share.title, share.icon, share.description);
			    }
	    });
    },
    goBack() {
    	this.params('', '', 'goBack');
    }
  },
//mounted() {
//}
  
};
</script>
<style lang="less" scoped>
.toShare {
  background: #f2f2f2;
  .van-nav-bar {
    background: #f2f2f2;
    padding-top: 24px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 12 !important;
    .van-nav-bar__title {
      font-size: 18px;
      color: #333;
    }
    .van-icon-arrow-left:before {
      display: none;
    }
    .van-nav-bar__left {
      left: 11px;
      .van-icon {
        width: 17px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/plane/reBack.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
  
  .lunbo {
  	position: relative;
  	min-height: 200px;
  	height: auto;
  	.tip {
  		height: 16px;
    	line-height: 16px;
	  	color: #333;
	  	font-size: 14px;
	  	position: absolute;
	  	top: 3px;
	  	left: 12px;
	  	z-index: 10;
	  }
	  .swiper-container{
	  	padding-top: 30px;
	  	background: #f2f2f2;
	  	margin-bottom: 21px;
	  	.swiper-slide {
		    width: 50%;
		    background: #fff;
		    height: 250px;
		    border-radius: 10px;
		    position:relative;
		    .index {
		    	color: #FFFFFF;
		    }
		    .bg{
		    	position: absolute;
		    	display: inline-block;
		    	bottom: 0;
		    	left: 0;
		    	width: 100%;
		    	height: 100%;
		    	border-radius: 10px;
		    }
		    .qrcode{
		    	position: absolute;
		    	display: inline-block;
		    	bottom: 7px;
		    	left: 9px;
		    }
		  }
		  
		  .swiper-pagination {
		  	height: 16px;
    		line-height: 16px;
		  	text-align: left;
		  	top: 3px;
		  	color: #333;
		  	font-size: 14px;
		  	width: 45px;
		  	left: 70px;
		  }
	  }
  }
  
  /*.van-row {
    padding: 11px 0 17px 0;
    .van-col--24 {
      text-align: center;
      font-size: 13px;
      color: #333333;
    }
  }*/
  .share-btn {
    background: #fff;
    margin-bottom: 8px;
    .share_ {
      text-align: center;
      padding: 18px 0 11px 0;
      .register {
        font-size: 13px;
        color: #999999;
      }
    }
    .btn {
      padding-bottom: 20px;
      .btn-- {
        display: block;
        font-size: 16px;
        color: #ffffff;
        line-height: 48px;
        border-radius: 60px;
        text-align: center;
        margin: 0 25px 0 25px;
        background: linear-gradient(270deg, #F41A3C 0%, #FC740C 100%);
      }
      .btn--- {
      	display: block;
        font-size: 16px;
        color: #FF5619;
        line-height: 48px;
        border-radius: 60px;
        text-align: center;
        margin: 15px 25px 0 25px;
        border: solid 1px #FF5619;
      }
    }
  }
  .rule {
    background: #fff;
    overflow: hidden;
    .shareRule {
      text-align: center;
      margin: 20px 0 20px 0;
      font-size: 16px;
      color: #333333;
    }
    .rule-i {
      display: flex;
      margin-bottom: 29px;
      .rule-j {
        display: block;
        width: 100%;
        font-size: 13px;
        color: #333333;
        margin: 0 18px;
      }
      .circle {
        width: 36px;
        .crl {
          display: block;
          width: 7px;
          height: 7px;
          margin: 5px auto;
          background: -webkit-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(#feac7a, #ff6059); /* 标准的语法 */
          border-radius: 50%;
        }
      }
    }
  }
}

</style>


